import { application } from "./application";

import SearchController from "./search_controller";
import SearchSuggestController from "./search_suggest_controller";
import ShareController from "./share_controller";
import SupportCarouselController from "./support_carousel_controller";
import TestimonialCarouselController from "./testimonial_carousel_controller";
import NewsEventsCarouselController from "./news_events_carousel_controller";
import DelegateFocusController from "./delegate_focus_controller";
import ToggleController from "./toggle_controller";
import SelectController from "./select_controller";
import HeaderController from "./header_controller";
import AppziController from "./appzi_controller";
import EggyShowController from "./eggy_show_controller";
import KidsTopicDropdownController from "./kids_topic_dropdown_controller";
import KidsTopicTabsController from "./kids_topic_tabs_controller";
import VideoModalController from "./video_modal_controller";
import KidsPageTransitionController from "./kids_page_transition_controller";

application.register("search", SearchController);
application.register("search-suggest", SearchSuggestController);
application.register("support-carousel", SupportCarouselController);
application.register("testimonial-carousel", TestimonialCarouselController);
application.register("news-events-carousel", NewsEventsCarouselController);
application.register("share", ShareController);
application.register("delegate-focus", DelegateFocusController);
application.register("toggle", ToggleController);
application.register("select", SelectController);
application.register("header", HeaderController);
application.register("appzi", AppziController);
application.register("eggy-show", EggyShowController);
application.register("kids-topic-dropdown", KidsTopicDropdownController);
application.register("kids-topic-tabs", KidsTopicTabsController);
application.register("video-modal", VideoModalController);
application.register("kids-page-transition", KidsPageTransitionController);
